
import React from 'react';
import { thc, Checkbox } from '@flightstats/airframe-react';

const CheckBoxWrapper = thc<any>(
  Checkbox as any,
  { margin: '0 !important' },
  { '& p': { margin: 0 } },
  {
    '& div': {
      borderColor: 'white !important',
    },
  },
  {
    '& input:checked + div::after': {
      position: 'relative',
      top: '15%',
    },
  },
);

type StyledCheckBoxProps = {
  id: string,
  name?: string,
  checked: boolean,
  onChange: () => void,
  label: string,
};

export const StyledCheckBox = (props: StyledCheckBoxProps) => {
  const { id, name, checked, onChange, label } = props;

  return (
    <CheckBoxWrapper
      name={name ?? id}
      id={id}
      checked={checked}
      onChange={onChange}
      boldLabel={false}
    >
      {label}
    </CheckBoxWrapper>
  );
};
